export default "__VITE_ASSET__PAo7vis1__"